import { insuranceService } from '../../network';
import {
  GET_INSURANCE_BROKERS,
  SET_INSURANCE_BROKERS,
  FETCH_INSURANCE_BROKERS,
  POST_INSURANCE_BROKER,
  PUT_INSURANCE_BROKER,
  DELETE_INSURANCE_BROKER
} from './types';

const store = {};
const getDefaultState = () => ({
  insuranceBrokers: []
});

store.state = getDefaultState();

store.getters = {
  [GET_INSURANCE_BROKERS](state) {
    return state.insuranceBrokers.map((broker) => ({
      key: broker.id,
      id: broker.id,
      rut: broker.rut,
      name: broker.businessName,
      label: broker.label
    }));
  }
};

store.mutations = {
  [SET_INSURANCE_BROKERS](state, payload) {
    state.insuranceBrokers = payload;
  }
};

store.actions = {
  [FETCH_INSURANCE_BROKERS]({ commit }) {
    return new Promise((resolve, reject) => {
      insuranceService
        .getInsuranceBrokers()
        .then((resp) => {
          commit(SET_INSURANCE_BROKERS, resp.data);
          resolve(resp);
        })
        .catch((error) => {
          commit(SET_INSURANCE_BROKERS, []);
          reject(error);
        });
    });
  },
  async [POST_INSURANCE_BROKER](_, { payload }) {
    let error = '';
    const response = await insuranceService
      .postInsuranceBroker(payload)
      .catch((err) => (error = err));
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    }
    throw error;
  },
  async [PUT_INSURANCE_BROKER](_, { insuranceBrokerId, payload }) {
    let error = '';
    const response = await insuranceService
      .putInsuranceBroker(insuranceBrokerId, payload)
      .catch((err) => (error = err));
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    }
    throw error;
  },
  [DELETE_INSURANCE_BROKER](_, payload) {
    return new Promise((resolve, reject) => {
      insuranceService
        .deleteInsuranceBroker(payload)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default store;
